import React, { useEffect, useState, useContext } from 'react';
import './TreatmentDetailContent.scss';
import { getTreatmentBySlug } from '../../services/treatmentService';
import TreatmentSidebar from '../../components/TreatmentSidebar/TreatmentSidebar';
import { LanguageContext } from '../../context/LanguageContext';

const TreatmentDetailContent = ({ slug }) => {
    const [treatment, setTreatment] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { currentLang } = useContext(LanguageContext);

    useEffect(() => {
        const fetchTreatment = async () => {
            try {
                setLoading(true);
                const data = await getTreatmentBySlug(slug, currentLang);
                console.log('TreatmentDetailContent - Gelen data:', data);
                if (data) {
                    console.log('TreatmentDetailContent - Content:', data.content);
                    setTreatment(data);
                    setError(null);
                } else {
                    setError('Tedavi içeriği bulunamadı.');
                }
            } catch (err) {
                console.error('Tedavi içeriği yüklenirken hata:', err);
                setError('Tedavi içeriği yüklenirken bir hata oluştu.');
            } finally {
                setLoading(false);
            }
        };

        fetchTreatment();
    }, [slug, currentLang]);

    if (loading) {
        return (
            <section className="treatment-detail-content">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p>Yükleniyor...</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    if (error || !treatment) {
        return (
            <section className="treatment-detail-content">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <p>{error || 'Tedavi içeriği bulunamadı.'}</p>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    return (
        <section className="treatment-detail-content">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8">
                        <div className="content-wrapper">
                            <div className="treatment-content">
                                {/* Debug için */}
                                {console.log('Render edilecek content:', treatment.content)}
                                {!treatment.content || treatment.content.length === 0 ? (
                                    <div>
                                        <p>Bu tedavi için henüz içerik eklenmemiş.</p>
                                        <p>Debug: treatment.content = {JSON.stringify(treatment.content)}</p>
                                    </div>
                                ) : (
                                    treatment.content.map((block, index) => {
                                        console.log('Render edilen block:', block); // Debug
                                        switch (block.type) {
                                            case 'rich-text':
                                                return <div key={index} dangerouslySetInnerHTML={{ __html: block.content }} />;
                                            case 'subtitle':
                                                return <h2 key={index}>{block.content}</h2>;
                                            case 'sub-content':
                                                return <div key={index} dangerouslySetInnerHTML={{ __html: block.content }} />;
                                            default:
                                                return <div key={index}>Bilinmeyen block tipi: {block.type}</div>;
                                        }
                                    })
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <TreatmentSidebar treatment={treatment} />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default TreatmentDetailContent; 